<!-- 🚀 CANDADO DE ARQUITECTURA: Desactiva por completo la caché de hidratación de Angular SSR -->
<div ngSkipHydration>

  <!-- 🌐 HEADER SUPERIOR CORPORATIVO (ESTILO NAV PANEL) -->
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm mb-4 px-3 rounded-bottom">
    <div class="container-fluid p-0 d-flex justify-content-between align-items-center">
      
      <!-- Lado Izquierdo: Identidad de Marca ERP -->
      <div class="d-flex align-items-center gap-2">
        <span class="fs-5 fw-bold text-white mb-0" style="letter-spacing: 0.5px;">🛠️ Sistema de Control Automotriz</span>
        <span class="badge bg-secondary font-monospace" style="font-size: 0.72rem; opacity: 0.85;">JDE AB MASTER</span>
      </div>

      <!-- Lado Derecho: Botón de Salida Segura Alineado a la Derecha -->
      <div class="d-flex align-items-center gap-3">
        <button type="button" 
                class="btn btn-sm btn-outline-light d-flex align-items-center gap-2 fw-bold px-3 py-1 border-0"
                style="font-size: 0.82rem; border-radius: 6px; background-color: rgba(255,255,255,0.08); transition: all 0.2s;"
                onmouseover="this.style.backgroundColor='rgba(220,53,69,0.2)'; this.style.color='#ffc107';"
                onmouseout="this.style.backgroundColor='rgba(255,255,255,0.08)'; this.style.color='#fff';"
                (click)="ejecutarCerrarSesion()">
          <span>🚪</span> Cerrar Sesión Segura
        </button>
      </div>

    </div>
  </nav>

  <!-- 📊 CONTENEDOR DE LA TABLA PRINCIPAL -->
  <div class="container-fluid px-3">
    
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2 class="h5 m-0 fw-bold text-dark text-uppercase" style="letter-spacing: 0.5px;">Listado de Clientes Corporativos</h2>
      <a class="btn btn-primary btn-sm px-4 fw-bold shadow-sm" routerLink="/customers/add" routerLinkActive="active" style="border-radius: 6px;">
        ➕ Crear Nuevo Cliente
      </a>
    </div>

    <div class="card mb-3 border-0 shadow-sm bg-light">
      <div class="card-body p-2">
        <div class="row g-2">
          <!-- Filtro Universal de Texto Sincronizado -->
          <div class="col-md-12">
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0">🔍</span>
              <input type="text" 
                    class="form-control border-start-0 ps-0 text-uppercase" 
                    id="busquedaCliente" 
                    name="busquedaCliente"
                    [(ngModel)]="filtroTexto" 
                    (input)="filtrarClientes()" 
                    placeholder="Buscar por nombre comercial, razón social, RFC o código AN8...">
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="table table-hover table-striped border shadow-sm">
      <thead class="table-dark">
        <tr>
          <th scope="col" style="width: 140px;">CÓDIGO AN8</th>
          <th scope="col" style="width: 160px;">RFC</th>
          <th scope="col">RAZÓN SOCIAL LEGAL</th>
          <th scope="col" class="text-center" style="width: 110px;">Eliminar</th>
          <th scope="col" class="text-center" style="width: 110px;">Editar</th>
        </tr>
      </thead>
      <tbody class="align-middle">
        <!-- 🚀 CAMBIADO: Ahora itera sobre el getter 'customersPaginados' para recortar la cuadrícula a 10 filas -->
        <tr *ngFor="let c of customersPaginados; trackBy: trackByAn8">
          <th scope="row" class="font-monospace text-primary fw-bold">{{ c.an8 }}</th>
          <td class="text-uppercase font-monospace">{{ c.rfc }}</td>
          <td class="fw-semibold text-dark">{{ c.razonSocial }}</td>
          
          <td class="text-center"> 
            <button class="btn btn-danger btn-sm px-3" (click)="deleteCustomer(c.an8)">
              ❌ Eliminar
            </button> 
          </td>
          
          <td class="text-center"> 
            <button class="btn btn-info btn-sm text-white px-3" (click)="editCustomer(c)">
              ✏️ Actualizar
            </button> 
          </td>
        </tr>
        
        <!-- Fila de respaldo amigable por si la base de datos está vacía -->
        <tr *ngIf="customersFiltrados.length === 0">
          <td colspan="5" class="text-center text-muted py-4">
            No se encontraron clientes aprobados en el Address Book de la base de datos.
          </td>
        </tr>
      </tbody>
    </table>

    <!-- ========================================================================= -->
    <!-- 🎛️ BOTONERA ERGONÓMICA: BOTONES A LA IZQUIERDA Y LEYENDAS A LA DERECHA      -->
    <!-- ========================================================================= -->
    <div class="d-flex justify-content-between align-items-center mt-3 border-top pt-2">
      
      <!-- 🧭 BARRA DE PAGINACIÓN INTERACTIVA DE ALTO RENDIMIENTO CON SALTOS EXTREMOS (IZQUIERDA) -->
      <nav aria-label="Navegación de catálogos">
        <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">
          
          <!-- 🚀 Botón de Salto al Inicio Absoluto (Primera Página) -->
          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(1)" style="cursor: pointer;" title="Ir a la primera página">
              ⏮️ Primera
            </button>
          </li>

          <!-- Botón de Retroceder Anterior -->
          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)" style="cursor: pointer;">
              ◀️ Anterior
            </button>
          </li>

          <!-- Píldora Central Indicadora Estilo ERP Modular -->
          <li class="page-item disabled">
            <span class="page-link bg-light text-dark font-monospace border fw-bold px-3">
              PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
            </span>
          </li>

          <!-- Botón de Avanzar Siguiente -->
          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)" style="cursor: pointer;">
              Siguiente ▶️
            </button>
          </li>

          <!-- 🚀 Botón de Salto al Final Absoluto (Última Página) -->
          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(totalPaginas)" style="cursor: pointer;" title="Ir a la última página">
              Última ⏭️
            </button>
          </li>

        </ul>
      </nav>

      <!-- 📊 RENDIMIENTO DE CONTEO Y LEYENDAS INDEXADAS EN RED (DERECHA) -->
      <span class="text-muted small text-end">
        Mostrando clientes del <strong>{{ ((paginaActual - 1) * registrosPorPagina) + 1 }}</strong> 
        al <strong>{{ Math.min(paginaActual * registrosPorPagina, customersFiltrados.length) }}</strong> 
        de un total de <strong>{{ customersFiltrados.length }}</strong> indexados en red.
      </span>

    </div>

  </div>

  <!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS CORPORATIVOS (UNIFICADO EN LIMPIO) -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
    <div *ngFor="let toast of toastService.toasts" 
         class="toast show shadow border-0 mb-2" 
         [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
         role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
        <strong class="me-auto d-flex align-items-center gap-2">
          <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
          {{ toast.title }}
        </strong>
        <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
      </div>
      <div class="toast-body pt-0" style="font-size: 0.85rem;">
        {{ toast.text }}
      </div>
    </div>
  </div>

</div>

<router-outlet></router-outlet>